import { cn } from "@/lib/utils";
import { Platform, TextInput, type TextInputProps } from "react-native";

/**
 * Single-line text field.
 *
 * On iOS, Tailwind `text-base` sets lineHeight 24 with fontSize 16. UITextField
 * centers the placeholder with that metrics, but typed text sits lower. Keep
 * fontSize without an oversized lineHeight on native.
 *
 * On Android, default includeFontPadding adds extra ascent space that clips
 * placeholder/value inside fixed-height shells when font scale is increased.
 */
function Input({
    className,
    style,
    ...props
}: TextInputProps & React.RefAttributes<TextInput>) {
    return (
        <TextInput
            className={cn(
                "border-input text-foreground flex w-full font-sans",
                props.editable === false && "opacity-50",
                Platform.select({
                    web: "outline-none text-base leading-5",
                    // text-[16px] only — do not use text-base (it injects lineHeight: 24).
                    default: "text-[16px]",
                }),
                className,
            )}
            style={[
                Platform.OS === "ios"
                    ? { paddingVertical: 0 }
                    : Platform.OS === "android"
                      ? { includeFontPadding: false, paddingVertical: 0 }
                      : null,
                style,
            ]}
            {...props}
        />
    );
}

export { Input };
